import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Tooltip,
  IconButton,
  Box,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import moment from "moment";

const getRelatedName = (relatedType) => {
  switch (relatedType) {
    case 0:
      return "Card";
    case 1:
      return "Pack";
    default:
      return "?";
  }
};

const getActivityName = (relatedType) => {
  switch (relatedType) {
    case 0:
      return "Add on Sale";
    case 1:
      return "Sell";
    case 2:
      return "Buy";
    case 3:
      return "Remove from Sale";
    default:
      return "?";
  }
};
export default function ActivityTable(props) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Activity</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  Target ID
                  <Tooltip 
                    title={
                      <div>
                        <div>If type is card, this is card ID</div>
                        <div>If type is pack, this is pack ID</div>
                      </div>
                    }
                    arrow
                  >
                    <IconButton size="small" sx={{ p: 0.25 }}>
                      <Info fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.activity?.map((row, index) => {
              const isLast = index === props.activity.length - 1;
              return (
                <TableRow
                  key={index}
                  ref={isLast ? props.lastActivityRef : null}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {getActivityName(row.activityType)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {getRelatedName(row.relatedType)}
                  </TableCell>

                  <TableCell component="th" scope="row">
                    {row.relatedId}
                  </TableCell>
                  <TableCell>{moment(row.createdAt).format("ddd MMM D, YYYY h:mm A")}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
